<script setup>
import { computed } from 'vue'
import { useFilingDetailStore } from '../../stores/filingDetailStore'
import { useRoute, useRouter } from 'vue-router'
import StatusBadge from './StatusBadge.vue'

const filingDetailStore = useFilingDetailStore()
const route = useRoute()
const router = useRouter()

// Compute the business address from the store
const address = computed(() => {
  const filing = filingDetailStore.currentFiling
  return {
    address1: filing.businessAddress1,
    address2: filing.businessAddress2,
    city: filing.businessCity,
    state: filing.businessState,
    zip: filing.businessZip,
    country: filing.businessCountry
  }
})

// Compute the path for editing the address
const editAddressPath = computed(() => {
  return `/a/${route.params.teamSlug}/filings/${route.params.filingId}/edit-address/`
})

// Function to handle edit button click
const navigateToEditAddress = () => {
  router.push(editAddressPath.value)
}
</script>

<template>
  <div class="card shadow-none border mb-3">
    <div class="card-header border-bottom pb-3">
      <h3 class="card-title">Business Address</h3>
      <StatusBadge :isComplete="filingDetailStore.isAddressComplete" />
    </div>
    <div class="card-body">
      <div class="row justify-content-md-between">
        <div class="col-md-12">
          <dl class="row">
            <dt class="col-4">Address</dt>
            <dd class="col-8">
              <address v-if="address.address1">
                {{ address.address1 }}<br />
                <span v-if="address.address2"
                  >{{ address.address2 }}<br
                /></span>
                {{ address.city }}, {{ address.state }} {{ address.zip }}<br />
                {{ address.country }}
              </address>
              <span v-else>No address provided</span>
            </dd>
          </dl>
        </div>
      </div>
      <div class="d-flex gap-2 justify-content-start">
        <div class="d-grid col-md-3">
          <button
            v-editable
            @click="navigateToEditAddress"
            class="btn btn-sm btn-outline-primary"
            type="button"
          >
            <i class="fa-light fa-pen-to-square" aria-hidden="true"></i>
            {{ address.address1 ? 'Edit' : 'Add' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
